class Index {
    rc;
    _parent;
    callRecordId;
    constructor(_parent, callRecordId = null) {
        this._parent = _parent;
        this.rc = _parent.rc;
        this.callRecordId = callRecordId;
    }
    path(withParameter = true) {
        if (withParameter && this.callRecordId !== null) {
            return `${this._parent.path()}/call-log/${this.callRecordId}`;
        }
        return `${this._parent.path()}/call-log`;
    }
    /**
     * Returns call log records filtered by parameters specified.
     * HTTP Method: get
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/call-log
     * Rate Limit Group: Heavy
     * App Permission: ReadCallLog
     * User Permission: FullCompanyCallLog
     */
    async list(queryParams, restRequestConfig) {
        const r = await this.rc.get(this.path(false), queryParams, restRequestConfig);
        return r.data;
    }
    /**
     * Returns individual call log record(s) by ID.
     * [Batch syntax](https://developers.ringcentral.com/guide/basics/batch-requests) is supported.
     *
     * HTTP Method: get
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/call-log/{callRecordId}
     * Rate Limit Group: Heavy
     * App Permission: ReadCallLog
     * User Permission: FullCompanyCallLog
     */
    async get(queryParams, restRequestConfig) {
        if (this.callRecordId === null) {
            throw new Error("callRecordId must be specified.");
        }
        const r = await this.rc.get(this.path(), queryParams, restRequestConfig);
        return r.data;
    }
}
export default Index;
